module.exports = __webpack_public_path__ + "static/media/previewAppTile.20809cae.png";